module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/index.js
// module id = 140
// module chunks = 35783957827783 107818501498521 231608221292675